import { Blog } from "../../loadBlogs";

export default function BlogItem(props : Blog) {
    return (
        <div className="blog w-full lg:w-full mx-auto h-fit bg-slate-800 p-4" id={"blog" + props.id}>
            <div className="blog-title text-xl text-orange-500 font-semibold mb-5 w-fit border-l-4 border-r-4 p-2 rounded-2xl">
                {props.title}
            </div>
            <div className="hr"></div>
            <div className="blog-content" dangerouslySetInnerHTML={{ __html: props.content }}>
            </div>
            <div className="blog-date text-sm text-orange-500">
                {props.date}
            </div>
        </div>
    )
}